import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Buttons } from '@/components/shared/buttons'
import { Inputs } from '@/components/shared/forms/Inputs'
import { Can } from '@/features/sessao/providers/auth-context'
import { CallEvidenceImage } from '@/services/backend/config/entities'
import { Repository } from '@/services/repository'

type Props = {
  callId: number
  onSuccess: (data: CallEvidenceImage) => void
}

function Form({ callId, onSuccess }: Props) {
  const { Create } = Repository.Entity.CallEvidenceImage

  const form = useForm<Parameters<typeof Create>[0]>({
    defaultValues: {
      callId,
    },
  })

  const onSubmit = form.handleSubmit(async (data) => {
    try {
      const res = await Create(data)
      toast.success('Evidência salva com sucesso')
      onSuccess(res)
      form.reset()
    } catch (error: any) {
      toast.error(error.message)
    }
  })

  return (
    <form onSubmit={onSubmit}>
      <VStack align="stretch" gap={4}>
        <FormControl>
          <FormLabel fontSize="sm">Imagem</FormLabel>
          <Inputs.Image useForm={form} useFormField="imageStr" />
        </FormControl>

        <HStack justifyContent="space-between" mt={8}>
          <Button type="submit" colorScheme="primary">
            Enviar
          </Button>
        </HStack>
      </VStack>
    </form>
  )
}

export default function Component({ onSuccess, ...props }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Can asDefault I="create" a="CallReportAttachment">
      <Buttons.Add onClick={onOpen} />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Novo</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Form
              onSuccess={(res) => {
                if (onSuccess) onSuccess(res)
              }}
              {...props}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Can>
  )
}
